import { useAtom } from 'jotai';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { reservationDataAtom } from '../jotai-atoms/reservation-data.atom';
import { CountdownWidget } from '../stories/CountdownWidget/CountdownWidget';
import { Tag } from '../stories/Tag';

interface EmbedCountdownProps {
  className?: string;
  isThin?: boolean;
}

export const EmbedCountdown: React.FC<EmbedCountdownProps> = ({ className, isThin }) => {
  const __ = useTranslation().t;

  const [reservationData] = useAtom(reservationDataAtom);

  return (
    <>
      <GreyBackground show={reservationData?.widgetState === 'class_started'} />
      <Container className={className}>
        <TagContainer>
          <Tag shape="vertical-label" variant="yellow-main">
            {__('nextLiveClass')}
          </Tag>
        </TagContainer>
        <StyledCountdownWidget size="md" isThin={isThin} />
      </Container>
    </>
  );
};

const Container = styled.div`
  position: relative;
  padding: 32px 0;

  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #e5f1ff;
  box-shadow: 0px 0px 24px rgba(30, 134, 251, 0.1);
  border-radius: 24px;

  width: 475px;
  margin: auto;
  margin-top: 50px;

  z-index: 3;

  @media screen and (max-width: ${({ theme }) => theme.screenSizes.sm}) {
    width: calc(100% - 32px);
    margin: 50px 16px 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.sm}) and (max-width: ${({
      theme,
    }) => theme.screenSizes.lg}) {
    width: calc(100% - 50px);
    margin: 50px 25px 0;
  }
`;

const TagContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  position: absolute;
  z-index: 1;
  width: 100%;
  top: -16px;
`;

interface GreyBackgroundProps {
  show: boolean;
}

const GreyBackground = styled.div<GreyBackgroundProps>`
  ${({ show }) => (!show ? `display: none;` : ``)}
  background-color: rgba(0, 0, 0, 0.25);
  position: fixed;
  inset: 0px;
  z-index: 2;
`;

const StyledCountdownWidget = styled(CountdownWidget)`
  background: ${({ theme }) => theme.colors.white};
`;
